const jQ = jQuery.noConflict();
class Counter {
    constructor(counterItem) {
        this.counterItem = counterItem;
    }
    countDecimals(number) {
        const numString = number.toString();
        const indexOfComma = numString.indexOf('.');
        const numOfDecimals = numString.length - indexOfComma;
        
        if(indexOfComma >= 1) {
            return numOfDecimals;
        }
        else {
            return 0;
        }
    }
    init(arg) {
        const counterItems = jQ(this.counterItem);
        
        counterItems.each((index, element) => {
            let counterEnd = null;
            let counterStart;
            const counterKj = jQ(element).data('counter-kj');
            const counterCal = jQ(element).data('counter-cal');
            const counterFat = jQ(element).data('counter-fat');
            const counterCarbs = jQ(element).data('counter-carbs');
            const counterProtein = jQ(element).data('counter-protein');

            if(counterKj) {
                counterEnd = counterKj;
                counterStart = arg ? Number(arg['counter-kj']) : 0;
            }
            else if(counterCal) {
                counterEnd = counterCal;
                counterStart = arg ? Number(arg['counter-cal']) : 0;
            }
            else if(counterFat) {
                counterEnd = counterFat;
                counterStart = arg ? Number(arg['counter-fat']) : 0;
            }
            else if(counterCarbs) {
                counterEnd = counterCarbs;
                counterStart = arg ? Number(arg['counter-carbs']) : 0;
            }
            else if(counterProtein) {
                counterEnd = counterProtein;
                counterStart = arg ? Number(arg['counter-protein']) : 0;
            }
            
            if(counterEnd !== undefined) {
                const decimals = this.countDecimals(counterEnd);
               
                jQ({Counter: counterStart}).animate({Counter: counterEnd}, {
                	duration: 2000,
                	easing: 'linear',
                	step: function () {
                        if(decimals > 1) {
                            jQ(element).text(this.Counter.toFixed(1));
                        }
                        else {
                            jQ(element).text(Math.ceil(this.Counter));
                        }
                    }
                }); 
            }
        });
    }
}

const counterBottom =  new Counter('.article-info .list-item-middle');
const counterMiddle = new Counter('.article-info .counter-item-number');
export default counterBottom;
export {
    counterMiddle

}